import * as React from 'react';
import { useAutoExecuteState } from "app/area/case-report/hooks";
import { RiskMatrixListing } from "app/area/case-report/risk-listing/risk-matrix-listing";
import { useInstanceOptions } from "app/area/favourite/favourite-context";
import { useSelectors as useRiskReportSelectors } from 'app/area/case-report/risk-listing/hooks';
import { useTranslation } from "app/infrastructure/translate/hooks";
import { caseListingTranslation } from "app/area/case-report/case-listing/constants";
import { STATE } from "app/constants";
import { riskReportTranslation } from "app/area/case-report/risk-listing/constants";
import { CaseReportFailedExecute } from "app/area/case-report/components/case-report-failed-execute";
import { Switch } from "ui/common/switch/switch";
import styles from './risk-matrix-listing.scss';
import { FavouriteResultComponentProps } from "app/area/favourite/types";
import { selectionReportTranslations } from 'app/area/reports/constants';

export const RiskReportContainer = (props: FavouriteResultComponentProps) => {
  const {
    hideVisualizationOptions
  } = useInstanceOptions();

  const { riskReportResults, errorsExecuteFailed, fetching } = useRiskReportSelectors();

  const {
    autoExecute,
    toggleAutoExecution
  } = useAutoExecuteState();

  const translation = useTranslation(STATE.caseListing, caseListingTranslation);
  const riskReportTranslations = useTranslation(STATE.riskReport, riskReportTranslation);
  const { drill_down_to, drill_down_to_done } = useTranslation(STATE.selectionReport, selectionReportTranslations);

  const hasExecuteFailedErrors = autoExecute && !!errorsExecuteFailed && !!errorsExecuteFailed.length;

  const executeFailed = hasExecuteFailedErrors ? <CaseReportFailedExecute
    translation={translation}
    errorsExecuteFailed={errorsExecuteFailed} /> : null;

  const result = <RiskMatrixListing
    translation={{...riskReportTranslations, ...{drill_down_to, drill_down_to_done} }}
    autoExecute={autoExecute}
    riskReportResults={riskReportResults}
    fetching={fetching}
    workingDefinition={props.workingDefinition}
    executeFailed={executeFailed}
    toggleAutoExecution={toggleAutoExecution}
    hideVisualizationOptions={hideVisualizationOptions}
  />;

  if (hideVisualizationOptions) {
    return result;
  }

  return <div className={`caselisting riskmatrixlisting`}>
    <div className={styles.switch}>
      <Switch
        checked={autoExecute}
        onChange={toggleAutoExecution}
        label={translation.toggle_info_load_options}
      />
    </div>
    {result}
  </div>;
};
